import create from 'zustand'
import { fetchRegistrationCertificate } from '../api'

export const useRegistrationCertificatesStore = create((set, get) => ({
	registrationCertificates: [],
	totalRegistrationCertificatesCount: 0,
	searchString: '',
	setSearchString: (searchString) =>
		set({
			searchString,
		}),
	pageNumber: 0,
	hasRegistrationCertificatesInitiallyLoaded: false,
	loadError: null,
	uploadCertificateModalOpen: false,
	setUploadCertificateModalOpen: (uploadCertificateModalOpen) => {
		set({
			uploadCertificateModalOpen,
		})
	},
	bulkUploadModalOpen: false,
	setBulkUploadModalOpen: (bulkUploadModalOpen) => {
		set({
			bulkUploadModalOpen,
		})
	},
	manualDateInputModalOpen: false,
	setManualDateInputModalOpen: (manualDateInputModalOpen) => {
		set({
			manualDateInputModalOpen,
		})
	},
	certificatesNeedingDates: [],
	setCertificatesNeedingDates: (certificatesNeedingDates) => {
		set({
			certificatesNeedingDates,
		})
	},
	bulkUploadInProgress: false,
	setBulkUploadInProgress: (bulkUploadInProgress) => {
		set({
			bulkUploadInProgress,
		})
	},
	incrementRegistrationCertificateImageCount: ({
		registrationCertificateId,
		incrementImageCountBy,
	}) => {
		const registrationCertificates = get().registrationCertificates
		const foundRegistrationCertificateIndex =
			registrationCertificates.findIndex(
				(rc) => rc.registration_certificate_id === registrationCertificateId,
			)
		if (foundRegistrationCertificateIndex < 0) {
			return
		}
		registrationCertificates[
			foundRegistrationCertificateIndex
		].registered_image_count += incrementImageCountBy
		set({
			registrationCertificates,
		})
	},
	fetchRegistrationCertificates: async (input) => {
		const state = get()

		const pageNumber = input && input.isInitialLoad ? 0 : get().pageNumber

		let registrationCertificatesResponse
		try {
			registrationCertificatesResponse = await fetchRegistrationCertificate({
				page: pageNumber,
				perPage: 50,
				...(state.searchString
					? {
							filters: {
								registrationCertificateNumber: state.searchString,
							},
						}
					: {}),
			})
		} catch (error) {
			console.error(error)
			set({
				loadError:
					'Could not load registration certificates. Please try again later.',
				hasRegistrationCertificatesInitiallyLoaded: true,
			})
			return
		}

		const { data, pagination } = registrationCertificatesResponse || {}

		// Listing across partners is restricted to admins, so a failure here is
		// most often a permission error the user needs to see.
		if (!data || !pagination) {
			set({
				loadError:
					(registrationCertificatesResponse &&
						registrationCertificatesResponse.message) ||
					'Could not load registration certificates. Please try again later.',
				hasRegistrationCertificatesInitiallyLoaded: true,
			})
			return
		}

		set({
			registrationCertificates:
				input && input.isInitialLoad
					? data
					: [...state.registrationCertificates, ...data],
			totalRegistrationCertificatesCount: pagination.totalItems,
			pageNumber: pageNumber + 1,
			hasRegistrationCertificatesInitiallyLoaded: true,
			loadError: null,
		})
	},
	removeRegistrationCertificate: (registrationCertificateId) => {
		const registrationCertificates = get().registrationCertificates
		const updatedRegistrationCertificates = registrationCertificates.filter(
			(rc) => rc.registration_certificate_id !== registrationCertificateId,
		)
		set({
			registrationCertificates: updatedRegistrationCertificates,
			totalRegistrationCertificatesCount:
				updatedRegistrationCertificates.length,
		})
	},
}))
